import StaticEquation from './StaticEquation';

export { StaticEquation };
